import React from "react";
import {observer} from "mobx-react";
import useConstrainable from "../hooks/use-constrainable";

function AutoFetchFilter() {

    const constrainable = useConstrainable();

    React.useEffect(() => {
        constrainable.constrain();
    });

    return null;
}

export default observer(AutoFetchFilter);
